import styled, {css, FlattenSimpleInterpolation} from 'styled-components'
import {darkGray} from '@modifi/colors'
import {Container} from '@modifi/ui'

export const BasicCardsContainer = styled(Container)`
  overflow: hidden;
`

type BasicCardContentProps = {
  isActive?: boolean
  containerWidth: number
  numberOfCards: number
  isFirstCard: boolean
  isLastCard: boolean
}

export const BasicCardContent = styled.div<BasicCardContentProps>`
  min-height: 218px;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 6px;
  transition: background-color 200ms, color 200ms;
  color: ${darkGray};
  margin-left: 8px;
  margin-right: 16px;
  text-wrap: wrap;
  ${(p): string => (p.isFirstCard && p.numberOfCards > 1 ? 'margin-left: 0;' : '')}
  ${(p): string => (p.isLastCard && p.numberOfCards > 1 ? 'margin-right: 0;' : '')}

  & > p {
    margin: 0;
    white-space: normal;
  }
`

type StyledImgProps = {
  imageRatio?: string
}

export const StyledImg = styled.img<StyledImgProps>`
  width: 288px;
  height: 288px;
  object-fit: cover;
  ${({imageRatio}): FlattenSimpleInterpolation | string =>
    imageRatio === '23'
      ? css`
          width: 392px;
          height: 256px;
        `
      : ''}
`
